import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useTools from '../../hooks/useTools';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import './FeaturedProducts.css';

const FeaturedProducts = () => {

    const [tools, setTools] = useTools();

    var settings = {
        dots: true,
        // className: "center",
        centerMode: false,
        // infinite: true,
        centerPadding: "0px",
        slidesToShow: 1.5,
        // autoplay: true,
        speed: 500,
        rows: 2,
        slidesPerRow: 2,
        nextArrow: <IoIosArrowForward id='arrow-right' />,
        prevArrow: <IoIosArrowBack id='arrow-left' />,

        // appendDots: dots => (
        //     <div
        //         style={{
        //             borderRadius: "3px",
        //             padding: "3px"
        //         }}
        //     >
        //         <ul style={{ margin: "8px" }}> {dots} </ul>
        //     </div>
        // ),


        responsive: [
            {
                breakpoint: 1040,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: .5,
                    slidesToScroll: .5,
                    initialSlide: .5
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: .5,
                    slidesToScroll: .5
                }
            }
        ]
    };


    return (
        <div className='lg:mt-14 mt-7'>

            <h2 className='text-2xl font-bold mb-10'><span className='text-underline'>Featured Products</span></h2>
            <div className='bg-white py-3 px-3'>
                <Slider {...settings}>
                    {
                        tools.map((tool, Index) =>
                            <div className='px-2 py-2 cursor cursor-pointer'>
                                <div className='flex px-2 py-2 border hover:border-[#ffd000] img-holder'>

                                    <img id='item-img-1' className='mx-auto w-28 lg:w-32 h-28' src={`${tool.img}`} alt="" />

                                    {/* Amazing technique! I am proud of me! */}
                                    {<img id='item-img-2' className='mx-auto w-28 lg:w-32 h-28' src={`${tools?.[Index + 1]?.img}`} alt="" />}

                                    <div className='pl-3 hover:underline'>
                                        <h3>{tool.name}</h3>
                                        <p className=''>Available: {tool.available} PCs</p>
                                        <p className='font-bold text-[#ffd000] text-lg'>${tool.price}.00</p>
                                    </div>
                                </div>
                            </div>)
                    }
                </Slider>
            </div>
        </div>
    );
};

export default FeaturedProducts;